import { createContext, useCallback, useMemo, useState } from "react";
import { Invoice } from "src/api/types";
import CreditNoteModal from "src/components/PatientInvoices/components/CreditNoteModal";

type ContextType = {
  invoice: Invoice | null;
  handleOpenCreditNote: (invoice: Invoice | null) => void;
};

export const InvoiceModalContext = createContext<ContextType>({
  invoice: null,
  handleOpenCreditNote: () => {},
});

interface Props {
  children: React.ReactNode;
}

const InvoiceModalProvider = ({ children }: Props) => {
  const [invoice, setInvoice] = useState<Invoice | null>(null);
  const [openCreditNote, setOpenCreditNote] = useState<boolean>(false);

  const handleOpenCreditNote = useCallback((invoice: Invoice | null) => {
    setInvoice(invoice);
    setOpenCreditNote(true);
  }, []);

  const handleCloseCreditNote = useCallback(() => {
    setInvoice(null);
    setOpenCreditNote(false);
  }, []);

  const value = useMemo(
    () => ({ invoice, handleOpenCreditNote }),
    [handleOpenCreditNote, invoice],
  );

  return (
    <InvoiceModalContext.Provider value={value}>
      {children}
      {invoice ? (
        <CreditNoteModal
          invoice={invoice.external_id}
          onClose={handleCloseCreditNote}
          open={openCreditNote}
        />
      ) : null}
    </InvoiceModalContext.Provider>
  );
};

export default InvoiceModalProvider;
